import { AppContent } from '../AppContent';
import { MetaContentValues } from '../metaContentValues';

const legalResponsibilities: AppContent['legalResponsibilities'] = {
  metaContent: {
    title: MetaContentValues.legalResponsibilities.title,
  },
  backLabel: 'Back to Landlord support',
  pageTitle: 'Legal responsibilities',
  asALandlord:
    'As a landlord, there are certain things you must do with your rental property. These apply for the whole of the UK, but Wales, Scotland and Northern Ireland also have their own additional responsibilities. You can find out more about these in the relevant sections',
  yourRentalPropertyMust: {
    title: 'Your rental property must:',
    listItem1:
      'be safe to live in and free of anything that could be a health hazard for tenants',
    listItem2:
      'have correctly installed and maintained electrical and gas appliances',
    listItem3:
      'be fitted with smoke and carbon monoxide alarms that are tested regularly',
    listItem4: 'have a valid ',
    linkLabel: 'energy performance certificate',
    epc: ' (EPC).',
  },
  tenantResponsibilities: {
    title: 'There are also responsibilities you have for your tenants:',
    listItem1: 'You must check tenants have the right to rent your property.',
    listItem2:
      'You must protect tenant deposits in a government-approved scheme.',
  },
  tenantsInEngland: {
    title: 'All tenants in England',
    givenACopy: 'Must be given a copy of the ',
    checklistLinkLabel: 'How to rent checklist',
    checklistLinkHref: 'https://www.gov.uk/government/publications/how-to-rent',
    findLatestInfo: 'You can find the latest information around ',
    rentersRightsLinkLabel: "renters' rights legislation in England here",
    rentersRightsLinkHref:
      'https://www.gov.uk/government/publications/guide-to-the-renters-rights-bill',
    rentalFlats:
      "Rental flats in purpose-built blocks or a house or building that's been adapted must also follow relevant fire safety regulations.",
    purposeBuiltLinkLabel: 'Fire regulations for purpose-built flats',
    purposeBuiltLinkHref:
      'https://www.local.gov.uk/publications/fire-safety-purpose-built-flats',
    adaptedLinkLabel: 'Fire regulations for building adapted into flats',
    adaptedLinkHref:
      'https://www.gov.uk/government/collections/fire-safety-legislation-guidance-for-those-with-legal-duties',
    period: '.',
  },
  walesAccordion: {
    label: 'Rental property in Wales?',
    landlordInWales: 'To be a landlord in Wales, you must register with ',
    rentSmartLinkLabel: 'Rent Smart Wales',
    rentSmartLinkHref: 'https://rentsmart.gov.wales/en/home/',
    finedIfNotRegistered: ". You could be fined if you're not registered.",
    rentingHomesAct:
      'All community, social, and private landlords in Wales must follow The Renting Homes (Wales) Act 2016.',
    contractHolders:
      'Under this act, tenants and licensees are called contract-holders. They must have occupation contracts, which replaced tenancy and licence arrangements, to live in the property.',
    privateLandlords:
      'For private landlords, these are known as standard contracts. Each contract must:',
    listItems: [
      'contain the names of the parties and address of the property',
      "cover the most important aspects of the contract, including the possession procedures and the landlord's repair obligations",
      'deal with the practical, day-to-day issues of the occupation contract. For example, the requirement for a contract-holder to notify the landlord if the property is going to be empty for four weeks or more.',
      'addresses other agreed points, for example the keeping of pets. Any additional terms must be fair, as required by the Consumer Rights Act 2015.',
    ],
    writtenStatement:
      'A written or email statement of the occupation contract containing all the contract terms must be sent to all contract-holders.',
    responsibilitiesLinkLabel: 'Landlord responsibilities in Wales',
    responsibilitiesLinkHref: 'https://www.gov.wales/renting-homes-landlords',
  },
  scotlandAccordion: {
    label: 'Rental property in Scotland?',
    additionalResponsibilities:
      'Landlords with properties rented out in Scotland have a few additional responsibilities. They must carry out a ',
    legionellaLinkLabel: 'legionella risk assessment',
    legionellaLinkHref:
      'https://www.hse.gov.uk/legionnaires/legionella-landlords-responsibilities.htm',
    and: ' and ',
    localCouncilLinkLabel:
      'register with the local council where their property is',
    localCouncilLinkHref: 'https://landlordregistrationscotland.gov.uk/',
    tenantsName: '. They also have to give tenants their name and address.',
    responsibilitiesLinkLabel: 'Landlord responsibilities in Scotland',
    responsibilitiesLinkHref:
      'https://www.mygov.scot/landlord-responsibilities',
  },
  northernIrelandAccordion: {
    label: 'Rental property in Northern Ireland?',
    landlordRegister:
      "All private landlords in Northern Ireland need to be registered before they can rent out a property. You could be fined up to £2,500 if you're not registered.",
    registrationProcessLinkLabel: 'Landlord registration process',
    registrationProcessLinkHref:
      'https://www.nidirect.gov.uk/articles/landlord-registration-process',
    tenancyInformationNotice:
      'You must provide your tenants with a free Tenancy Information Notice within 28 days of the start of the tenancy and a Notice of Variation if anything in the original tenancy information notice changes. If anything linked to the tenancy agreement is paid for in cash, a written receipt is required.',
    responsibilitiesLinkLabel: 'Landlord responsibilities in Northern Ireland',
    responsibilitiesLinkHref:
      'https://www.nidirect.gov.uk/articles/landlord-and-tenant-obligations#toc-1',
  },
  newLandlordAccordion: {
    label: 'New to being a landlord?',
    findEverything: "You'll find everything you need ",
    linkLabel: 'here',
    findEverythingLinkHref: 'https://www.gov.uk/renting-out-a-property',
    period: '.',
  },
};

export default legalResponsibilities;
